import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

import AuthLayout from "@/components/layout/AuthLayout.vue";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { CompanyUserService } from "@/services/CompanyUserService";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerUserRegisterView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const companyUserService = new CompanyUserService();
const { showToast } = useToast();

const token = ref("");
const email = ref("");
const tokenError = ref(false);
const submitting = ref(false);
const formRef = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(
  null
);

const rules = {
  required: (v: string) => !!v?.trim() || "Kötelező mező",
  minPassword: (v: string) =>
    v?.length >= 8 || "A jelszónak legalább 8 karakter hosszúnak kell lennie",
  passwordMatch: (v: string) =>
    v === form.value.password || "A jelszavak nem egyeznek",
};

const form = ref({
  firstName: "",
  lastName: "",
  password: "",
  passwordConfirm: "",
});

onMounted(async () => {
  token.value = route.query.token as string;
  if (!token.value) {
    tokenError.value = true;
    return;
  }
  try {
    const result = await companyUserService.validateToken(token.value);
    email.value = result.email;
  } catch {
    tokenError.value = true;
  }
});

async function submit() {
  const { valid } = await formRef.value!.validate();
  if (!valid) return;

  submitting.value = true;
  try {
    await companyUserService.registerUser({
      token: token.value,
      firstName: form.value.firstName,
      lastName: form.value.lastName,
      password: form.value.password,
    });
    showToast("Sikeres regisztráció");
    router.push("/login");
  } catch (e) {
    if (e?.response?.status === 409) {
      showToast("Ez az email cím már regisztrálva van a rendszerben", "error");
    } else {
      showToast("Regisztráció sikertelen", "error");
    }
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthLayout, { "max-width": 480 }, {
    default: _withCtx(() => [
      (tokenError.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_icon, {
              color: "error",
              size: "56",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-alert-circle")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_title, { class: "justify-center mb-2" }, {
              default: _withCtx(() => [
                _createTextVNode("Érvénytelen link")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("A meghívó link érvénytelen vagy már felhasználták.")
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_card_title, { class: "mb-4" }, {
              default: _withCtx(() => [
                _createTextVNode("Regisztráció")
              ]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              ref_key: "formRef",
              ref: formRef,
              onSubmit: _withModifiers(submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: email.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      label: "Email cím",
                      readonly: "",
                      disabled: "",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.lastName) = $event)),
                      label: "Vezetéknév",
                      class: "mb-2",
                      rules: [rules.required]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.firstName) = $event)),
                      label: "Keresztnév",
                      class: "mb-2",
                      rules: [rules.required]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.password) = $event)),
                      label: "Jelszó",
                      type: "password",
                      class: "mb-2",
                      rules: [rules.required, rules.minPassword]
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.passwordConfirm,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.passwordConfirm) = $event)),
                      label: "Jelszó megerősítése",
                      type: "password",
                      rules: [rules.required, rules.passwordMatch]
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      color: "primary",
                      loading: submitting.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Regisztráció")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ], 64))
    ]),
    _: 1
  }))
}
}

})